import {
  useState, useRef,
} from 'react';

export default function useToggleState(initialState = false) {
  const [isActive, setIsActive] = useState(initialState);
  const open = useRef(() => {
    setIsActive(true);
  });
  const close = useRef(() => {
    setIsActive(false);
  });
  const toggle = useRef(() => {
    setIsActive((currentIsActive) => !currentIsActive);
  });
  return {
    isActive,
    open: open.current,
    close: close.current,
    toggle: toggle.current,
  };
}
